import { createFileRoute } from "@tanstack/react-router";
import BcbsksInsurance from "@/pages/BcbsksInsurance";
export const Route = createFileRoute("/bcbsks-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS Kansas TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield Kansas coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "BCBS Kansas TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield Kansas coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/bcbsks-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/bcbsks-insurance",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsksInsurance />;
}
